import React, { Component } from 'react';
import { reduxForm, formValueSelector, Field, change } from 'redux-form';
import { connect } from 'react-redux';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from './CustomAlert.js';
import { WAButton } from './Button.js';
import SaveStepButton from './SaveStepButton.js';
import RenderField from './RenderField';
import axios from 'axios';

class MzaActiveForm extends Component {

    constructor(props) {
        super(props);
        this.state = { is_company: 0 };
        this.state = {};
    }
    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/param?param=is_company`, config).then((response)=> {
            this.setState({
                is_company: response.data.is_company,
            });
            if (this.state.is_company == 1){
                const { dispatch, form } = this.props;
                dispatch(change(form, 'has_mza_active', '0'));
            }
        });
    }
    render() {
        const { handleSubmit, submitting, error, isMzaActive } = this.props;

        const mzaActiveOption = [{id:0 , name:'Si'}, {id:1 , name:'No'}];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_mza_active" description="Mza Active"/>
                        <div className="show-desktop">
                            <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveMzaActive)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            {(this.state.is_company == 0) && (
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="has_mza_active" defaultValue="Selecciona una opción" label="Selecciona una opción" attributeName='has_mza_active' attributeOptions={mzaActiveOption}/>
                                    </div>
                                </div>
                            </div>
                            )}
                            {(isMzaActive === '0' || isMzaActive === '1' || this.state.is_company == 1) && (
                                <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className={error ? "form-group has-error" : "form-group"}>
                                        <div className="help-block">
                                            <Field className="form-control" name="mza_active_ticket" autoComplete="off" component={RenderField} type="number" label={isMzaActive === '1' ? "Ingrese el N° de ticket del beneficiario con crédito fiscal" : "Ingrese el N° de ticket del beneficio" } />
                                            {((error && <span>{'No existe ticket asociado al cuil'}</span>))}
                                            </div>
                                    </div>
                                </div>
                            </div>
                            )}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

MzaActiveForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('MzaActiveForm')

MzaActiveForm = connect(
    state => {
        const isMzaActive = selector(state, 'has_mza_active')
        return {
            isMzaActive
        }
    }
)(MzaActiveForm)

let validate = generateValidator([{name: 'has_mza_active', required: true},{name: 'mza_active_ticket', required: true}])
MzaActiveForm = TopScrolleable(MzaActiveForm);

MzaActiveForm = reduxForm({
    form: 'MzaActiveForm', // a unique name for this form
    validate
})(MzaActiveForm);

MzaActiveForm = withAuthControl(MzaActiveForm);

export default MzaActiveForm;


/** WEBPACK FOOTER **
 ** ./src/components/MzaActiveForm.js
 **/